import axios from "axios";
import { config } from "../config";
import { getAuthHeader } from "../customAuth/authContext";
import { CollectionResponse } from "../models/responses/CollectionResponse";

const backendUrl = `${config.apiServerUrl}/collection`;

export const getCollectionsApi = async () => {
    try {
        const response = await axios.get(`${backendUrl}/all`, {
            headers: {
                Authorization: getAuthHeader()
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching collections:', error);
        throw error;
    }
}

export const addCollectionApi = async (model: CollectionResponse) => {
    try {
        const response = await axios.post(`${backendUrl}/add`, model, {
            headers: {
                Authorization: getAuthHeader()
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error adding collection:', error);
        throw error;
    }
}

export const updateCollectionApi = async (model: CollectionResponse) => {
    try {
        const response = await axios.put(`${backendUrl}/edit`, model, {
            headers: {
                Authorization: getAuthHeader()
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating collection:', error);
        throw error;
    }
}

export const deleteCollectionApi = async (id: number) => {
    try {
        const response = await axios.delete(`${backendUrl}/delete?id=${id}`, {
            headers: {
                Authorization: getAuthHeader()
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting collection:', error);
        throw error;
    }
}